<p-toast styleClass="notification-toast" [position]="isMobile ? 'bottom-center' : 'bottom-right'" [baseZIndex]="baseZIndex">
  <ng-template let-message pTemplate="message">
    <app-message
      class="notification-message"
      [type]="message?.data?.type"
      [title]="message?.summary"
      [content]="message?.detail"
    ></app-message>
  </ng-template>
</p-toast>
